import { parseInlineCSS } from '@lumapps/utils/css/parseInlineCSS';
import { and } from '@lumapps/utils/function/predicate/and';
import { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute, matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME } from '../../../components/blocks/Button';
import { BUTTON } from '../../../constants';
import { createButton } from '../../../utils/createButton';

type ElementTypes = typeof BUTTON;
const LUMX_BUTTON_CLASSNAME = 'lumx-button';

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    button: {
        test: and(
            matchNode({ tagName: 'a' }),
            // href should not be empty
            matchAttribute('href', /.*/),
            matchAttribute('className', new RegExp(LUMX_BUTTON_CLASSNAME)),
        ),
        testParent: and(matchNode({ tagName: 'div' }), matchAttribute('className', new RegExp(CLASSNAME))),
        type: BUTTON,
        transform: ({ properties }: any, children: any) => {
            const styleObject = parseInlineCSS(properties.style);

            const styleColor = styleObject?.['--lumx-button-emphasis-high-state-default-theme-light-color'] || '';
            const styleBackgroundColor =
                styleObject?.['--lumx-button-emphasis-high-state-default-theme-light-background-color'] || '';

            return createButton({
                color: styleColor,
                backgroundColor: styleBackgroundColor,
                label: children[0].text,
                fullWidth: !!properties.className.includes('lumx-button--is-full-width'),
                ...(properties.href
                    ? {
                          href: properties.href,
                          target: '_blank',
                      }
                    : undefined),
            });
        },
    },
};
